import React, { useEffect } from 'react';
import ic_accept from "assets/images/ic_accept.svg";
import ic_reject from "assets/images/ic_reject.svg";

import { func_datetime, func_validation, getObjectPropertyValue, isNumberValid, isStringEqual_caseInsensitive, isStringTrimNotEmpty } from 'functions';
import { Spinner } from 'components/loaders/Spinner';
import { Tooltip } from 'components/informational/Tooltip';

export function useTableColumns({ 
    updatingSingleRowPos, setIsModalVisible, setSingleCOMDetail, 
    setIsSingleUpdate, isRejecting, currentTabId
}) {

    function getColumn_comID() {
        let columnClassName = "columns__com-id";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Com ID",
            id: "companyId",
            accessor: "ComId",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis d-flex align-items-center"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_requester() {
        let columnClassName = "columns__requester flex-fill";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Requester",
            id: "requester",
            accessor: "Requester",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_requestDate() {
        let columnClassName = "columns__request-date align-items-center";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Request date",
            id: "requestDate",
            accessor: "RequestDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_respondDate() {
        let columnClassName = "columns__respond-date align-items-center";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Respond date",
            id: "respondDate",
            accessor: "UpdateDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_action() {
        let columnClassName = "columns__action";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Action",
            id: "action",
            accessor: "RequestStatus",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let status = props?.cell?.value;
                let rowIndex = props?.row?.index;
                let isActionRequired = !(isStringEqual_caseInsensitive(status, "Done") || isStringEqual_caseInsensitive(status, "Rejected"));

                return (
                    <div className={"d-flex"}>
                        {/* Accept */}
                        <div className={"action__accept d-flex align-item-center " +
                                (!isActionRequired? "invisible ":"") +
                                ((updatingSingleRowPos.current == rowIndex) && (!isRejecting.current)? "action__accept_visible ":"")}
                            onClick={() => {
                                let data = props?.row? props.row: {};
                                setSingleCOMDetail(data);
                                setIsModalVisible(true);
                                setIsSingleUpdate(true);
                                isRejecting.current = false;
                            }}
                        >
                            {(updatingSingleRowPos.current == rowIndex) && (!isRejecting.current)? ( 
                                <Spinner className={"accept__spinner"} size={0} />
                            ):(<img
                                className={"accept__icon"}
                                src={ic_accept}
                            />)}
                            <span className={"accept__text"}>Accept</span>
                        </div>

                        {/* Reject */}
                        <div className={"action__reject d-flex align-item-center " +
                                (!isActionRequired? "invisible ":"") +
                                ((updatingSingleRowPos.current == rowIndex) && isRejecting.current? "action__reject_visible ":"")}
                            onClick={() => {
                                let data = props?.row? props.row: {};
                                setSingleCOMDetail(data);
                                setIsModalVisible(true);
                                setIsSingleUpdate(true);
                                isRejecting.current = true;
                            }}
                        >
                            {(updatingSingleRowPos.current == rowIndex) && isRejecting.current? ( 
                                <Spinner className={"reject__spinner"} size={0} />
                            ):(<img
                                className={"reject__icon"}
                                src={ic_reject}
                            />)}
                            <span className={"reject__text"}>Reject</span>
                        </div>
                    </div>
                );
            },
            width: 250
        }
    }

    function getColumn_respondDate() {
        let columnClassName = "columns__respond-date align-items-center";

        return {
            headerCellClassName: columnClassName,
            Header: "Respond date",
            id: "respondDate",
            accessor: "UpdateDate",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_requestReason() {
        let columnClassName = "columns__request-reason";
    
        return {
            headerCellClassName: columnClassName,
            Header: "Request Reason",
            id: "requestReason",
            accessor: "RequestReason",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"request-reason__content"}
                        target={(
                            <div className={"noWrap-text-ellipsis"}>
                                {value_formatted}
                            </div>
                        )}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 300
        }
    }

    function getColumns_responseReason() {
        let columnClassName = "columns__response-reason";
    
        return {
            headerCellClassName: columnClassName,
            Header: "Response Reason",
            id: "responseReason",
            accessor: "ResponseReason",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"response-reason__content"}
                        target={(
                            <div className={"noWrap-text-ellipsis"}>
                                {value_formatted}
                            </div>
                        )}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 300
        }
    }

    function getColumn_status() {
        let columnClassName = "columns__status flex-fill";

        return {
            headerCellClassName: columnClassName + " ",
            Header: (currentTabId == "comList")? "Status": "Request Type",
            id: "status",
            accessor: "RequestName",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                switch (value) {
                    case "ReactiveComId": value_formatted = "COM Reactivation"; break;
                    case "TrialToBillableCom": value_formatted = "Trial Activation"; break;
                }

                return (
                    <div className={"noWrap-text-ellipsis"}>
                        <span>{value_formatted}</span>
                    </div>
                );
            },
        }
    }


    if (currentTabId === "pending") {
        return [
            getColumn_comID(),
            getColumn_requester(),
            getColumn_status(),
            getColumn_requestDate(),
            getColumns_requestReason(),
            getColumn_action()
        ]
    }
    else {
        return [
            getColumn_comID(),
            getColumn_requester(),
            getColumn_status(),
            getColumn_requestDate(),
            getColumn_respondDate(),
            getColumns_requestReason(),
            getColumns_responseReason(),
        ]
    }
    
}